import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  result: [],
  topics: {},
  total_items: null,
  topics_are_fetching: false,
  topic_is_fetching: false,
  can_load_more_topics: true,
  no_more_topics: false,
  page: 1,
  canRead: false,
});

export default (state = initialState, action) => {
  let topics_result_array;
  let new_followings_array;

  switch (action.type) {
    case ActionTypes.RESETING_TOPICS:
      return state
        .set('page', 1)
        .set('total_items', null)
        .updateIn(['result'], (result) => result.clear())
        .updateIn(['topics'], (topics) => topics.clear());

    case ActionTypes.FETCHING_TOPICS:
      return state
        .set('can_load_more_topics', false)
        .set('topics_are_fetching', true);

    case ActionTypes.FETCHED_TOPICS:
      topics_result_array = state
        .get('result')
        .push(...action.payload.topics.result.topics);

      return state
        .set('page', state.get('page') + 1)
        .set('total_items', action.payload.total_items)
        .set(
          'no_more_topics',
          state.get('topics').size >= action.payload.total_items,
        )
        .set(
          'can_load_more_topics',
          state.get('topics').size < action.payload.total_items,
        )
        .set('topics_are_fetching', false)
        .set('result', topics_result_array)
        .set('canRead', true)
        .mergeIn(['topics'], fromJS(action.payload.topics.entities.topics));

    case ActionTypes.FETCHING_TOPIC:
      return state.set('topic_is_fetching', true);

    case ActionTypes.FETCHED_TOPIC:
      return state
        .mergeIn(['topics'], fromJS(action.payload.entities.topics))
        .setIn(
          ['topics', action.payload.result.toString(), 'fetched_at'],
          Date.now(),
        )
        .set('topic_is_fetching', false);

    case ActionTypes.UPDATE_APPROVAL_ID:
      return state.setIn(
        ['topics', action.payload.topicId.toString(), 'approval_id'],
        action.payload.id,
      );

    case ActionTypes.FOLLOWED_TOPIC:
      new_followings_array = state.getIn([
        'topics',
        getTopicID(action.payload, 'followings'),
        'followings',
      ]);

      new_followings_array.push(action.payload.result);

      return state.mergeIn(
        ['topics', getTopicID(action.payload, 'followings'), 'followings'],
        fromJS(new_followings_array),
      );

    case ActionTypes.UNFOLLOWED_TOPIC:
      new_followings_array = state.getIn([
        'topics',
        getTopicID(action.payload, 'followings'),
        'followings',
      ]);

      new_followings_array.splice(
        new_followings_array.indexOf(action.payload.result),
        1,
      );

      return state.mergeIn(
        ['topics', getTopicID(action.payload, 'followings'), 'followings'],
        fromJS(new_followings_array),
      );

    default:
      return state;
  }
};

function getTopicID(payload, relation_name) {
  return payload.entities[relation_name][payload.result].topic_id.toString();
}
